import { useState } from 'react';
import { THEME_COLORS } from '../../../constants/horseConstants';

// Available horse sprites with normal and fat variants - ALPHABETICAL ORDER
const HORSE_SPRITES = [
  { id: 'appaloosa', name: 'Appaloosa', url: '/api/sprites/appaloosa_transparent.png', fatUrl: '/api/sprites/appaloosa_fat_transparent.png' },
  { id: 'appaloosa_bay', name: 'Appaloosa Bay', url: '/api/sprites/appaloosa_bay_transparent.png', fatUrl: '/api/sprites/appaloosa_bay_fat_transparent.png' },
  { id: 'bay', name: 'Bay', url: '/api/sprites/bay_transparent.png', fatUrl: '/api/sprites/bay_fat_transparent.png' },
  { id: 'bay_pinto', name: 'Bay Pinto', url: '/api/sprites/bay_pinto_transparent.png', fatUrl: '/api/sprites/bay_pinto_fat_transparent.png' },
  { id: 'bay_roan', name: 'Bay Roan', url: '/api/sprites/bay_roan_transparent.png', fatUrl: '/api/sprites/bay_roan_fat_transparent.png' },
  { id: 'black', name: 'Black', url: '/api/sprites/black_transparent.png', fatUrl: '/api/sprites/black_fat_transparent.png' },
  { id: 'black_pinto', name: 'Black Pinto', url: '/api/sprites/black_pinto_transparent.png', fatUrl: '/api/sprites/black_pinto_fat_transparent.png' },
  { id: 'blue_roan', name: 'Blue Roan', url: '/api/sprites/blue_roan_transparent.png', fatUrl: '/api/sprites/blue_roan_fat_transparent.png' },
  { id: 'buckskin', name: 'Buckskin', url: '/api/sprites/buckskin_transparent.png', fatUrl: '/api/sprites/buckskin_fat_transparent.png' },
  { id: 'buckskin_pinto', name: 'Buckskin Pinto', url: '/api/sprites/buckskin_pinto_transparent.png', fatUrl: '/api/sprites/buckskin_pinto_fat_transparent.png' },
  { id: 'buckskin_roan', name: 'Buckskin Roan', url: '/api/sprites/buckskin_roan_transparent.png', fatUrl: '/api/sprites/buckskin_roan_fat_transparent.png' },
  { id: 'burro', name: 'Burro (Gray)', url: '/api/sprites/burro_transparent.png', fatUrl: '/api/sprites/burro_fat_transparent.png' },
  { id: 'burro_chocolate', name: 'Burro (Choc)', url: '/api/sprites/burro_chocolate_transparent.png', fatUrl: '/api/sprites/burro_chocolate_fat_transparent.png' },
  { id: 'chestnut', name: 'Chestnut', url: '/api/sprites/chestnut_transparent.png', fatUrl: '/api/sprites/chestnut_fat_transparent.png' },
  { id: 'cremello', name: 'Cremello', url: '/api/sprites/cremello_transparent.png', fatUrl: '/api/sprites/cremello_fat_transparent.png' },
  { id: 'dun', name: 'Dun', url: '/api/sprites/dun_transparent.png', fatUrl: '/api/sprites/dun_fat_transparent.png' },
  { id: 'gray', name: 'Gray', url: '/api/sprites/gray_transparent.png', fatUrl: '/api/sprites/gray_fat_transparent.png' },
  { id: 'grulla', name: 'Grulla', url: '/api/sprites/grulla_transparent.png', fatUrl: '/api/sprites/grulla_fat_transparent.png' },
  { id: 'palomino', name: 'Palomino', url: '/api/sprites/palomino_transparent.png', fatUrl: '/api/sprites/palomino_fat_transparent.png' },
  { id: 'pali_pinto', name: 'Pali Pinto', url: '/api/sprites/pali_pinto_transparent.png', fatUrl: '/api/sprites/pali_pinto_fat_transparent.png' },
  { id: 'red_roan', name: 'Red Roan', url: '/api/sprites/red_roan_transparent.png', fatUrl: '/api/sprites/red_roan_fat_transparent.png' },
  { id: 'sorrel', name: 'Sorrel', url: '/api/sprites/sorrel_transparent.png', fatUrl: '/api/sprites/sorrel_fat_transparent.png' },
  { id: 'strawberry_roan', name: 'Strawberry', url: '/api/sprites/strawberry_roan_transparent.png', fatUrl: '/api/sprites/strawberry_roan_fat_transparent.png' },
];

// Available backgrounds for the sprite display area
const BACKGROUNDS = [
  {
    id: 'desert',
    name: 'Desert',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/scrmxw40_9814A067-DA7A-42A7-B4FB-0ADC21E55D5F.png'
  },
  {
    id: 'desert_river',
    name: 'Desert River',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/h4beeggv_C70D959D-A3CE-4526-B84D-42750190C09F.png'
  },
  {
    id: 'winter_stream',
    name: 'Winter Stream',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/cvoo4hbz_9E76C21C-2CAF-41F8-A510-96C332FD4B90.png'
  },
  {
    id: 'mountain_meadow',
    name: 'Mountain Meadow',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/gq661dge_1F0960F9-9ED0-4B5C-BD4B-B2F3752CFA89.png'
  },
  {
    id: 'prairie',
    name: 'Prairie',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/4jdfra2y_IMG_0644.png'
  },
  {
    id: 'canyon',
    name: 'Canyon Vista',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/3zx86k4i_IMG_0645.png'
  },
  {
    id: 'waterfall',
    name: 'Mountain Lake',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/p9hyev4v_IMG_0651.png'
  },
  {
    id: 'desert_dusk',
    name: 'Desert Dusk',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/wphq9kd0_IMG_0653.png'
  },
  {
    id: 'golden_plains',
    name: 'Golden Plains',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/pw6vc275_IMG_0654.png'
  },
  {
    id: 'desert_overlook',
    name: 'Desert Overlook',
    type: 'image',
    value: 'https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/20wzqav5_IMG_0656.png'
  },
  {
    id: 'pasture',
    name: 'Pasture',
    type: 'gradient',
    value: 'linear-gradient(to bottom, #bae6fd, #bbf7d0)'
  },
  {
    id: 'sunset',
    name: 'Sunset',
    type: 'gradient',
    value: 'linear-gradient(to bottom, #fcd34d, #f97316, #dc2626)'
  },
  {
    id: 'night',
    name: 'Night',
    type: 'gradient', 
    value: 'linear-gradient(to bottom, #1e3a5f, #0f172a)'
  },
];

/**
 * Status Bar Component - displays hunger/grooming level
 */
const StatusBar = ({ label, value, color, icon }) => {
  const getStatusColor = (val) => {
    if (val >= 70) return '#4CAF50'; // Green
    if (val >= 40) return '#FFC107'; // Yellow
    return '#F44336'; // Red
  };

  const barColor = color || getStatusColor(value);

  return (
    <div className="mb-3">
      <div className="flex justify-between items-center mb-1">
        <span className="text-sm font-medium text-gray-700 flex items-center gap-1">
          {icon} {label}
        </span>
        <span className="text-sm font-bold" style={{ color: barColor }}>
          {value}%
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${value}%`,
            backgroundColor: barColor,
            boxShadow: `0 0 6px ${barColor}40`
          }}
        />
      </div>
    </div>
  );
};

/**
 * Horse Interactive Card Component
 * Displays a horse sprite with hunger, water, grooming, and fitness status indicators
 * @param {object} mustang - The mustang data
 * @param {function} onSpriteChange - Callback when sprite is changed
 * @param {function} onFeed - Callback when feed button is clicked
 * @param {function} onWater - Callback when water button is clicked
 * @param {function} onGroom - Callback when groom button is clicked
 * @param {function} onExercise - Callback when exercise button is clicked
 * @param {boolean} isAdmin - Whether the user is an admin (enables preview mode)
 */
const HorseInteractiveCard = ({ mustang, onSpriteChange, onBackgroundChange, onDeleteBackground, onFeed, onWater, onGroom, onExercise, isAdmin = false }) => {
  // Initialize with mustang's selected sprite or default
  const spriteId = mustang.selected_sprite || 'black_pinto';
  const [selectedSprite, setSelectedSprite] = useState(spriteId);
  const [showSpriteSelector, setShowSpriteSelector] = useState(false);
  
  // Background selection state
  const backgroundId = mustang.selected_background || 'desert';
  const [selectedBackground, setSelectedBackground] = useState(backgroundId);
  const [showBackgroundSelector, setShowBackgroundSelector] = useState(false);
  const [availableBackgrounds, setAvailableBackgrounds] = useState(BACKGROUNDS);
  
  // Admin preview mode state
  const [previewMode, setPreviewMode] = useState(false);
  const [previewHunger, setPreviewHunger] = useState(mustang.hunger_level ?? 100);
  const [previewHydration, setPreviewHydration] = useState(mustang.hydration_level ?? 100);
  const [previewGrooming, setPreviewGrooming] = useState(mustang.cleanliness_level ?? 100);
  const [previewFitness, setPreviewFitness] = useState(mustang.fitness_level ?? 100);
  
  // Get status values - use preview values if in preview mode, otherwise use actual values
  const hungerLevel = previewMode ? previewHunger : (mustang.hunger_level ?? 100);
  const hydrationLevel = previewMode ? previewHydration : (mustang.hydration_level ?? 100);
  const groomingLevel = previewMode ? previewGrooming : (mustang.cleanliness_level ?? 100);
  const fitnessLevel = previewMode ? previewFitness : (mustang.fitness_level ?? 100);
  
  // Get the current sprite - use mustang's sprite directly if available
  const effectiveSprite = mustang.selected_sprite || selectedSprite;
  const currentSprite = HORSE_SPRITES.find(s => s.id === effectiveSprite) || HORSE_SPRITES[0];
  
  // Get the current background
  const effectiveBackground = mustang.selected_background || selectedBackground;
  const currentBackground = availableBackgrounds.find(b => b.id === effectiveBackground) || availableBackgrounds[0];
  
  // Simple sprite selection based on fitness level
  // Use fat sprite if fitness is low (< 50%) and fat sprite is available, otherwise use normal sprite
  const currentSpriteUrl = (fitnessLevel < 50 && currentSprite.fatUrl) ? currentSprite.fatUrl : currentSprite.url;

  // Handle sprite selection
  const handleSpriteSelect = (spriteId) => {
    setSelectedSprite(spriteId);
    setShowSpriteSelector(false);
    if (onSpriteChange) {
      onSpriteChange(spriteId);
    }
  };

  // Handle background selection
  const handleBackgroundSelect = (bgId) => {
    setSelectedBackground(bgId);
    setShowBackgroundSelector(false);
    if (onBackgroundChange) {
      onBackgroundChange(bgId);
    }
  };

  // Handle background deletion (admin only)
  const handleDeleteBackground = (bgId, e) => {
    e.stopPropagation();
    // Don't allow deleting gradient backgrounds
    const bgToDelete = availableBackgrounds.find(b => b.id === bgId);
    if (bgToDelete && bgToDelete.type === 'gradient') {
      return;
    }
    
    // Remove from available backgrounds
    const newBackgrounds = availableBackgrounds.filter(b => b.id !== bgId);
    setAvailableBackgrounds(newBackgrounds);
    
    // If the deleted background was selected, switch to first available
    if (selectedBackground === bgId) {
      setSelectedBackground(newBackgrounds[0]?.id || 'pasture');
    }
    
    // Notify parent component if callback provided
    if (onDeleteBackground) {
      onDeleteBackground(bgId);
    }
  };

  // Get background style based on type
  const getBackgroundStyle = () => {
    if (currentBackground?.type === 'image') {
      return {
        backgroundImage: `url(${currentBackground.value})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    }
    return {
      background: currentBackground?.value || 'linear-gradient(to bottom, #bae6fd, #bbf7d0)'
    };
  };

  return (
    <div className="space-y-4">
      {/* Admin Preview Toggle */}
      {isAdmin && (
        <div className="flex items-center justify-between bg-purple-100 border border-purple-300 rounded-lg px-3 py-2">
          <span className="text-sm font-medium text-purple-800">🎮 Admin Preview Mode</span>
          <button
            onClick={() => setPreviewMode(!previewMode)}
            className={`px-3 py-1 rounded-full text-xs font-bold transition-all ${
              previewMode 
                ? 'bg-purple-600 text-white' 
                : 'bg-white text-purple-600 border border-purple-300'
            }`}
            data-testid="toggle-preview-mode"
          >
            {previewMode ? 'ON' : 'OFF'}
          </button>
        </div>
      )}
      
      {/* Admin Preview Sliders */}
      {isAdmin && previewMode && (
        <div className="bg-purple-50 border border-purple-200 rounded-xl p-4 space-y-3" data-testid="admin-preview-panel">
          <h4 className="text-sm font-bold text-purple-800 mb-2">Adjust Stats to Preview Effects</h4>
          
          {/* Hunger Slider */}
          <div>
            <div className="flex justify-between text-xs text-purple-700 mb-1">
              <span>Hunger</span>
              <span className="font-bold">{previewHunger}%</span>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              value={previewHunger}
              onChange={(e) => setPreviewHunger(Number(e.target.value))}
              className="w-full h-2 bg-purple-200 rounded-lg appearance-none cursor-pointer accent-orange-500"
              data-testid="preview-hunger-slider"
            />
          </div>
          
          {/* Hydration Slider */}
          <div>
            <div className="flex justify-between text-xs text-purple-700 mb-1">
              <span>Hydration</span>
              <span className="font-bold">{previewHydration}%</span>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              value={previewHydration}
              onChange={(e) => setPreviewHydration(Number(e.target.value))}
              className="w-full h-2 bg-purple-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
              data-testid="preview-hydration-slider"
            />
          </div>
          
          {/* Grooming Slider */}
          <div>
            <div className="flex justify-between text-xs text-purple-700 mb-1">
              <span>Grooming</span>
              <span className="font-bold">{previewGrooming}%</span>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              value={previewGrooming}
              onChange={(e) => setPreviewGrooming(Number(e.target.value))}
              className="w-full h-2 bg-purple-200 rounded-lg appearance-none cursor-pointer accent-teal-500"
              data-testid="preview-grooming-slider"
            />
          </div>
          
          {/* Fitness Slider */}
          <div>
            <div className="flex justify-between text-xs text-purple-700 mb-1">
              <span>Fitness</span>
              <span className="font-bold">{previewFitness}%</span>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              value={previewFitness}
              onChange={(e) => setPreviewFitness(Number(e.target.value))}
              className="w-full h-2 bg-purple-200 rounded-lg appearance-none cursor-pointer accent-green-500"
              data-testid="preview-fitness-slider"
            />
          </div>
          
          {/* Quick Presets */}
          <div className="flex flex-wrap gap-2 pt-2 border-t border-purple-200">
            <button
              onClick={() => { setPreviewHunger(100); setPreviewHydration(100); setPreviewGrooming(100); setPreviewFitness(100); }}
              className="px-2 py-1 bg-green-500 text-white text-xs rounded-full hover:bg-green-600"
            >
              😊 Happy
            </button>
            <button
              onClick={() => { setPreviewHunger(25); setPreviewHydration(25); setPreviewGrooming(25); setPreviewFitness(25); }}
              className="px-2 py-1 bg-red-500 text-white text-xs rounded-full hover:bg-red-600"
            >
              😢 Sad
            </button>
            <button
              onClick={() => { setPreviewHunger(100); setPreviewHydration(100); setPreviewGrooming(20); setPreviewFitness(100); }}
              className="px-2 py-1 bg-amber-600 text-white text-xs rounded-full hover:bg-amber-700"
            >
              🧹 Dirty
            </button>
            <button
              onClick={() => { setPreviewHunger(15); setPreviewHydration(80); setPreviewGrooming(80); setPreviewFitness(80); }}
              className="px-2 py-1 bg-yellow-500 text-white text-xs rounded-full hover:bg-yellow-600"
            >
              🍽️ Hungry
            </button>
            <button
              onClick={() => { setPreviewHunger(80); setPreviewHydration(15); setPreviewGrooming(80); setPreviewFitness(80); }}
              className="px-2 py-1 bg-blue-500 text-white text-xs rounded-full hover:bg-blue-600"
            >
              💧 Thirsty
            </button>
          </div>
          
          {/* Simple Fitness Presets */}
          <div className="flex flex-wrap gap-2 pt-2 border-t border-purple-200">
            <span className="text-xs text-purple-600 font-medium w-full mb-1">Fitness Presets:</span>
            <button
              onClick={() => setPreviewFitness(25)}
              className="px-2 py-1 bg-red-600 text-white text-xs rounded-full hover:bg-red-700"
            >
              🐷 Fat
            </button>
            <button
              onClick={() => setPreviewFitness(75)}
              className="px-2 py-1 bg-green-500 text-white text-xs rounded-full hover:bg-green-600"
            >
              💪 Fit
            </button>
          </div>
        </div>
      )}
      
      {/* Horse Sprite Display */}
      <div 
        className="relative rounded-xl p-4 flex items-center justify-center"
        style={{ 
          minHeight: '200px',
          ...getBackgroundStyle()
        }}
      >
        {/* Background Selector Button */}
        <button
          onClick={() => setShowBackgroundSelector(!showBackgroundSelector)}
          className="absolute top-2 right-2 bg-white/80 hover:bg-white rounded-lg shadow-md transition-all z-10 p-1 hover:scale-105"
          data-testid="toggle-background-selector"
          title="Change background"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_equine-care-3/artifacts/y54e74im_AFF7D020-A832-42CA-AE92-A5A038BAD074.png"
            alt="Background"
            className="w-6 h-6 object-contain"
          />
        </button>
        
        {/* Background Selector Dropdown */}
        {showBackgroundSelector && (
          <div className="absolute top-10 right-2 bg-white border-2 border-gray-200 rounded-xl p-3 shadow-lg z-20" data-testid="background-selector">
            <h4 className="text-xs font-bold text-gray-700 mb-2">Choose Background</h4>
            <div className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto">
              {availableBackgrounds.map((bg) => (
                <div key={bg.id} className="relative">
                  <button
                    onClick={() => handleBackgroundSelect(bg.id)}
                    className={`p-1 rounded-lg border-2 transition-all hover:scale-105 w-full ${
                      selectedBackground === bg.id 
                        ? 'border-teal-500' 
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                    data-testid={`bg-option-${bg.id}`}
                  >
                    <div 
                      className="w-16 h-10 rounded"
                      style={bg.type === 'image' 
                        ? { backgroundImage: `url(${bg.value})`, backgroundSize: 'cover', backgroundPosition: 'center' }
                        : { background: bg.value }
                      }
                    />
                    <span className="text-xs text-gray-700 font-medium block mt-1 text-center">{bg.name}</span>
                  </button>
                  
                  {/* Delete button - only show for image backgrounds when admin preview mode is on */}
                  {previewMode && bg.type === 'image' && (
                    <button
                      onClick={(e) => handleDeleteBackground(bg.id, e)}
                      className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center text-xs font-bold shadow-md transition-all hover:scale-110"
                      title="Delete background"
                      data-testid={`delete-bg-${bg.id}`}
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        
        {/* Sprite Container with Visual Effects */}
        <div className="relative">
          {/* Horse Sprite */}
          {currentSpriteUrl && (
            <img
              src={currentSpriteUrl}
              alt={mustang.name}
              className="max-h-48 object-contain drop-shadow-lg"
              style={{ 
                filter: `drop-shadow(2px 4px 6px rgba(0,0,0,0.3)) ${
                  // Dirt/grooming effects - darken and add brown tint when dirty
                  groomingLevel < 30 
                    ? 'sepia(0.5) saturate(1.2) brightness(0.75) contrast(0.95)' 
                    : groomingLevel < 50 
                      ? 'sepia(0.35) saturate(1.1) brightness(0.85) contrast(0.97)' 
                      : groomingLevel < 70
                        ? 'sepia(0.15) brightness(0.92) contrast(0.98)'
                        : 'sepia(0) brightness(1) contrast(1)'
                }`,
                transition: 'filter 0.5s ease-in-out'
              }}
            />
          )}
          
          {/* Hunger Thought Bubble - shows grain bucket when hungry */}
          {hungerLevel < 50 && (
            <div 
              className="absolute -top-4 -right-2 animate-bounce"
              style={{ 
                animationDuration: '2s',
              }}
            >
              {/* Thought bubble container */}
              <div                className="relative bg-white rounded-full p-2 shadow-lg border-2 border-gray-200"
                style={{
                  width: hungerLevel < 25 ? '56px' : '48px',
                  height: hungerLevel < 25 ? '56px' : '48px',
                }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_75c371b3-7c68-4cba-b108-53128b488d0b/artifacts/mvf9g8y6_11407BFD-0675-4552-BDA6-0993B3288B87.png"
                  alt="Hungry"
                  className="w-full h-full object-contain"
                />
              </div>
              {/* Thought bubble dots */}
              <div className="absolute -bottom-1 left-1 w-3 h-3 bg-white rounded-full border border-gray-200"></div>
              <div className="absolute -bottom-3 left-0 w-2 h-2 bg-white rounded-full border border-gray-200"></div>
            </div>
          )}
          
          {/* Sweat/Water Drops - when thirsty */}
          {hydrationLevel < 50 && (
            <>
              <div 
                className="absolute text-lg animate-bounce"
                style={{ 
                  top: '5%', 
                  right: '15%',
                  animationDuration: '0.8s',
                  opacity: hydrationLevel < 30 ? 1 : 0.8
                }}
              >
                💧
              </div>
              <div 
                className="absolute text-base animate-bounce"
                style={{ 
                  top: '15%', 
                  right: '25%',
                  animationDuration: '1.1s',
                  animationDelay: '0.2s',
                  opacity: hydrationLevel < 40 ? 0.9 : 0.6
                }}
              >
                💧
              </div>
              {hydrationLevel < 30 && (
                <>
                  <div 
                    className="absolute text-sm animate-bounce"
                    style={{ 
                      top: '25%', 
                      right: '10%',
                      animationDuration: '1.3s',
                      animationDelay: '0.4s'
                    }}
                  >
                    💧
                  </div>
                  <div 
                    className="absolute text-xs animate-bounce"
                    style={{ 
                      top: '10%', 
                      left: '20%',
                      animationDuration: '1s',
                      animationDelay: '0.6s'
                    }}
                  >
                    💧
                  </div>
                </>
              )}
            </>
          )}
          
          {/* Sparkle Effect - shows briefly after grooming (when clean) */}
          {groomingLevel >= 90 && (
            <div className="absolute inset-0 pointer-events-none">
              <div 
                className="absolute w-3 h-3 animate-ping"
                style={{ top: '15%', left: '20%' }}
              >
                ✨
              </div>
              <div 
                className="absolute w-3 h-3 animate-ping"
                style={{ top: '25%', right: '25%', animationDelay: '0.3s' }}
              >
                ✨
              </div>
              <div 
                className="absolute w-3 h-3 animate-ping"
                style={{ bottom: '35%', left: '35%', animationDelay: '0.6s' }}
              >
                ✨
              </div>
            </div>
          )}
          
          {/* Happy Effect - when well-fed, hydrated, clean, and fit */}
          {hungerLevel >= 80 && hydrationLevel >= 80 && groomingLevel >= 70 && fitnessLevel >= 70 && (
            <div 
              className="absolute text-xl animate-bounce" 
              style={{ 
                animationDuration: '2s',
                top: '20%',
                left: '50%',
                transform: 'translateX(-50%)',
                color: THEME_COLORS.secondary
              }}
            >
              ♥
            </div>
          )}
          
          {/* Out of shape indicator */}
          {fitnessLevel < 40 && (
            <div className="absolute bottom-2 right-2 bg-pink-500 text-white px-2 py-1 rounded-full text-xs font-bold animate-pulse">
              Out of shape!
            </div>
          )}
        </div>
        
        {/* Change Sprite Button - moved to left side */}
        <button
          onClick={() => setShowSpriteSelector(!showSpriteSelector)}
          className="absolute top-2 left-2 bg-white/95 hover:bg-white rounded shadow-md transition-all z-10 hover:scale-105 flex items-center"
          style={{ padding: '0px 2px 0px 0', margin: 0, lineHeight: 0 }}
          title="Change sprite"
          data-testid="change-sprite-btn"
        >
          <img 
            src="/api/sprites/horse_head_icon.png"
            alt="Sprite"
            className="w-10 h-10 object-contain -m-2"
          />
          <span className="text-xs font-medium text-gray-700">Sprite</span>
        </button>
        
        {/* Status indicators on sprite */}
        {hungerLevel < 50 && (
          <div className="absolute bottom-2 left-2 bg-yellow-500 text-white px-2 py-1 rounded-full text-xs font-bold animate-pulse">
            Hungry!
          </div>
        )}
        {hydrationLevel < 50 && (
          <div className="absolute bottom-2 left-20 bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-bold animate-pulse">
            Thirsty!
          </div>
        )}
        {groomingLevel < 50 && (
          <div className="absolute bottom-2 left-2 bg-orange-500 text-white px-2 py-1 rounded-full text-xs font-bold animate-pulse">
            Needs grooming!
          </div>
        )}
      </div>

      {/* Sprite Selector Modal */}
      {showSpriteSelector && (
        <div className="bg-white border-2 border-gray-200 rounded-xl p-4 shadow-lg" data-testid="sprite-selector">
          <h4 className="text-sm font-bold text-gray-700 mb-3">Choose a Sprite ({HORSE_SPRITES.length} available)</h4>
          <div className="grid grid-cols-3 gap-3 max-h-64 overflow-y-auto pr-1">
            {HORSE_SPRITES.map((sprite) => (
              <button
                key={sprite.id}
                onClick={() => handleSpriteSelect(sprite.id)}
                className={`p-2 rounded-lg border-2 transition-all hover:scale-105 ${
                  selectedSprite === sprite.id 
                    ? 'border-teal-500 bg-teal-50' 
                    : 'border-gray-200 hover:border-gray-300'
                }`}
                data-testid={`sprite-option-${sprite.id}`}
              >
                <img
                  src={sprite.url}
                  alt={sprite.name}
                  className="w-full h-16 object-contain"
                />
                <span className="text-xs text-gray-700 font-medium block mt-1 text-center truncate w-full" title={sprite.name}>{sprite.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Status Bars */}
      <div className="bg-white rounded-xl p-4 border border-gray-200">
        <h4 className="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
          <span>Status</span>
          <span className="text-xs font-normal text-gray-500">({mustang.name})</span>
        </h4>
        
        <StatusBar 
          label="Hunger" 
          value={hungerLevel} 
          color={THEME_COLORS.primary}
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          }
        />

        <StatusBar 
          label="Water" 
          value={hydrationLevel}
          color="#3B82F6"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          }
        />
        
        <StatusBar 
          label="Grooming" 
          value={groomingLevel}
          color={THEME_COLORS.secondary}
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
          }
        />
        
        <StatusBar 
          label="Fitness" 
          value={fitnessLevel}
          color="#22C55E"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          }
        />
      </div>

      {/* Action Buttons */}
      <div className="grid grid-cols-4 gap-2">
        <button
          onClick={onFeed}
          className="flex flex-col items-center justify-center gap-1 py-2 px-1 rounded-xl font-bold transition-all hover:scale-105 active:scale-95"
          style={{ 
            backgroundColor: THEME_COLORS.primary,
            color: 'white',
            boxShadow: '0 4px 12px rgba(197, 106, 75, 0.3)'
          }}
          data-testid="feed-horse-btn"
        >
          <span className="flex items-center gap-1 text-xs">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Feed
          </span>
          <span className="text-xs opacity-80">10</span>
        </button>

        <button
          onClick={onWater}
          className="flex flex-col items-center justify-center gap-1 py-2 px-1 rounded-xl font-bold transition-all hover:scale-105 active:scale-95"
          style={{ 
            backgroundColor: '#3B82F6',
            color: 'white',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
          }}
          data-testid="water-horse-btn"
        >
          <span className="flex items-center gap-1 text-xs">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            Water
          </span>
          <span className="text-xs opacity-80">10</span>
        </button>
        
        <button
          onClick={onGroom}
          className="flex flex-col items-center justify-center gap-1 py-2 px-1 rounded-xl font-bold transition-all hover:scale-105 active:scale-95"
          style={{ 
            backgroundColor: THEME_COLORS.secondary,
            color: 'white',
            boxShadow: '0 4px 12px rgba(111, 207, 211, 0.3)'
          }}
          data-testid="groom-horse-btn"
        >
          <span className="flex items-center gap-1 text-xs">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
            Groom
          </span>
          <span className="text-xs opacity-80">10</span>
        </button>
        
        <button
          onClick={onExercise}
          className="flex flex-col items-center justify-center gap-1 py-2 px-1 rounded-xl font-bold transition-all hover:scale-105 active:scale-95"
          style={{ 
            backgroundColor: '#22C55E',
            color: 'white',
            boxShadow: '0 4px 12px rgba(34, 197, 94, 0.3)'
          }}
          data-testid="exercise-horse-btn"
        >
          <span className="flex items-center gap-1 text-xs">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            Exercise
          </span>
          <span className="text-xs opacity-80">10</span>
        </button>
      </div>

      {/* Tips */}
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-xs text-amber-800">
        <strong>Tip:</strong> Keep your horse well-fed, hydrated, groomed, and exercised for a happy, healthy horse! Low fitness makes your horse inflate.
      </div>
    </div>
  );
};

export default HorseInteractiveCard;
